<template>
    <v-card v-if="parameters.length > 0" outlined>
        <v-card-title>Query Parameters</v-card-title>

        <v-row v-for="(parameter, index) in parameters" v-bind:key="index">
            <v-card-text>
                <v-col class="my-n8">
                    <component :is="parameter.component" v-model="parameter.fields" />
                </v-col>
            </v-card-text>
        </v-row>
    </v-card>
</template>

<script>
    export default {
        props: [
            'parameters'
        ],
    }
</script>
